module.exports = __webpack_public_path__ + "media/images/online/online-wedding-icon-chapel-83044ac8466d9fc19fad4b5dfb669744.png";